import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@flatfy/supernova-new';
import { attachGaDataAttributes } from '../../helpers/analytics';

const FlatsFiltersChips = ({ item: { title, value, active, disabled, url }, name, onClick }) => {
  const [isActive, setIsActive] = useState(active);
  const toggleActive = (event) => {
    event.preventDefault();
    if (!disabled) {
      setIsActive(!isActive);
      onClick(value, !isActive);
    }
  };

  useEffect(() => {
    setIsActive(active);
  }, [active]);

  return (
    <Chip
      href={url}
      active={isActive}
      disabled={disabled}
      onClick={toggleActive}
      {...attachGaDataAttributes({
        category: window.eventCategory,
        action: 'filters',
        label: `${name}_${value}`,
      })}
    >
      {title}
    </Chip>
  );
};

FlatsFiltersChips.propTypes = {
  item: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    url: PropTypes.string,
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default FlatsFiltersChips;
